import NextCheckinsList from './NextCheckinsList.component';

export default NextCheckinsList;
